import React from 'react';

import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Text from 'components/Text';
import Row from 'components/Row';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';

export type RosteredDeviceProps = {
  name: string;
  deviceUid: string;
  onComplete?: () => void;
};

const RosteredDevice = ({
  name,
  deviceUid,
  onComplete,
}: RosteredDeviceProps): JSX.Element => {
  return (
    <BoxBody>
      <Row size="medium">
        <Text size="xsmall" align="left" wrap="force">
          {deviceUid} cannot be removed from {name} because it come from the SIS. Update their contact information in the SIS or <Link href={LinkConstants.ENABLE_SIS_ROSTERING_ENFORCEMENT} target="_blank">learn more</Link>.
        </Text>
      </Row>

      <Row size="small">
        <Button
          onClick={onComplete}
          data-test="merge-button"
          eventElementName="ContactMergeDialog-submit"
          type="submit"
          level="secondary"
          full>
          Okay
        </Button>
      </Row>
    </BoxBody>
  );
};

export default RosteredDevice;
